const initialState = {
  active: "none",
  index: [],
  data: {},
};

const Note = (state = initialState, action) => {
  switch (action.type) {
    case "CONTENT_NOTE_ACTIVE":
      return { ...state, active: action.payload.active };
    case "CONTENT_NOTE_INDEX":
      return { ...state, index: action.payload.index };
    case "CONTENT_NOTE_DATA":
      return { ...state, data: action.payload.data };
    case "CONTENT_NOTE_RESET":
      return initialState;
    default:
      return state;
  }
};

export default Note;
